import Sprite from '../sprites/sprite';
import React from 'react';

interface MetadataWithIconProps {
  text: string;
  icon: 'nights' | 'room' | 'person';
}

export const MetadataWithIcon: React.FC<MetadataWithIconProps> = ({ text, icon }) => {
  return (
    <div className="flex flex-row gap-1.5 items-center">
      <Sprite name={icon} width="20" height="20" />
      <p className="font-bold text-sm">{text}</p>
    </div>
  );
};
